import type { JSX } from 'react';

import { Button, Separator, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionGamma/details/pageContext';
import { SocialProofSunrise } from 'src/app/pages/petitionGamma/details/shared/components';

import { usePetitionSignatureCount } from '../../hooks/petitionStats';
import { useNextStepButtonAction } from '../../hooks/useNextStepButtonAction';
import { SignatureStatsActiveContainer } from '../stats/signatureStatsSunrise';

export function SideSignedPromotableContainer(): JSX.Element {
	const { signatureTargetLocalized } = usePetitionSignatureCount();
	const {
		data: { comboLink },
		action: { handleNextStepClick },
	} = useNextStepButtonAction();

	const {
		data: { signatureThermometerEnabled },
	} = usePetitionDetailsPageUserData();

	return (
		<div className="flex flex-col gap-6">
			<SignatureStatsActiveContainer />
			<Separator orientation="horizontal" className="border-stroke-weak" />
			<SocialProofSunrise />
			{!signatureThermometerEnabled && (
				<div className="px-4" data-testid="combo-action-text">
					<Text as="div" size="small">
						<Translate
							value="fe.pages.petition_update.combo_call_to_action_identified"
							replacements={{ signature_target: signatureTargetLocalized }}
						/>
					</Text>
				</div>
			)}
			<Button
				variant="primary"
				as="a"
				href={comboLink}
				onClick={handleNextStepClick}
				data-qa="signed-petition-combo-cta"
				className="w-full"
			>
				<Translate value="fe.pages.petition_update.combo_action_button_label" />
			</Button>
		</div>
	);
}
